import type { ComponentProps } from 'react'

import BookedOfferDetailsCTA from './BookedOfferDetailsCTA'

import type TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'
import LEBookingTag from 'tripPlanner/Tripkit/Common/LEBookingTag'
import type { TripItem } from 'tripPlanner/types/tripItem'
import { isLeBooking } from 'tripPlanner/utils'

interface Props {
  item: TripItem
  size?: ComponentProps<typeof TextButton>['size']
}

export default function BookedOfferDetailsButtonAndTagView({
  item,
  size = 'medium',
}: Props) {
  if (!isLeBooking(item)) return null
  return (
    <Group
      direction="vertical"
      tabletDirection="horizontal"
      gap={12}
      horizontalAlign="space-between"
      fullWidth
    >
      <LEBookingTag />
      <BookedOfferDetailsCTA item={item} size={size} />
    </Group>
  )
}
